import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooterComponent { }



// WEBPACK FOOTER //
// /var/www/hqsol/hqsol-live/app/src/app/components/app-footer/app-footer.component.ts